import { ArrowUp } from 'lucide-react';

const ICON_BTN_CLASS =
  'btn-reset grid size-8 flex-none place-items-center rounded-2xl bg-purple-default text-gray-inverse transition-colors ease-[ease] enabled:hover:bg-purple-hover disabled:opacity-50';

export default function SendOrStopButton({
  streaming,
  onStop,
  sendDisabled,
  stopLabel,
  sendLabel,
}: {
  streaming: boolean;
  onStop: () => void;
  sendDisabled: boolean;
  stopLabel: string;
  sendLabel: string;
}) {
  return streaming ?
      <button
        type="button"
        className={ICON_BTN_CLASS}
        aria-label={stopLabel}
        onClick={onStop}
      >
        <span className="size-3 rounded-[2px] bg-current" />
      </button>
    : <button
        type="submit"
        className={ICON_BTN_CLASS}
        aria-label={sendLabel}
        disabled={sendDisabled}
      >
        <ArrowUp size={20} />
      </button>;
}
